import React, { useState, useEffect  } from 'react';
import { X } from 'lucide-react';


const ProductModal = ({ item, isOpen, onClose }) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Clean up when modal unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen || !item) return null;

  const images = item.imageUrls && item.imageUrls.length > 0
    ? item.imageUrls
    : item.imageUrl
      ? [item.imageUrl]
      : [];

  const isDeal = item.category === 'Deals' && item.dealQuantity;

  return (
<div 
  className="fixed inset-0 flex items-center justify-center z-50 p-4"
  style={{
    backdropFilter: 'blur(10px)',
    backgroundColor: 'rgba(255, 255, 255, 0.1)'
  }}
>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col relative border border-gray-200">
        
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b bg-gray-50">
          {!isDeal && (
            <h2 className="text-xl font-bold text-gray-800">{item.name}</h2>
          )}
          <button 
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-200 transition"
          >
            <X size={24} />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto p-4 flex-grow space-y-6">
          
          {/* Image Preview */}
          <div className="h-64 flex items-center justify-center bg-gray-100 rounded-lg overflow-hidden relative">
            {images.length > 0 ? (
              <img 
                src={images[activeImageIndex]} 
                alt={item.name} 
                className="max-h-full max-w-full object-contain"
              />
            ) : (
              <div className="flex items-center justify-center w-full h-full text-gray-500 text-sm">
                No image available
              </div>
            )}
          </div>

          {/* Thumbnails */}
          {images.length > 1 && (
            <div className="flex mt-2 overflow-x-auto space-x-2 pb-2 scrollbar-thin scrollbar-thumb-gray-400">
              {images.map((image, index) => (
                <div 
                  key={index}
                  className={`h-16 w-16 flex-shrink-0 rounded overflow-hidden border-2 cursor-pointer ${
                    index === activeImageIndex ? 'border-green-500' : 'border-transparent'
                  }`}
                  onClick={() => setActiveImageIndex(index)}
                >
                  <img 
                    src={image} 
                    alt={`${item.name} ${index + 1}`}
                    className="h-full w-full object-cover"
                  />
                </div>
              ))}
            </div>
          )}

          {/* Deal Items List */}
          {isDeal && (
            <div className="space-y-1">
              <h3 className="text-base font-semibold text-gray-800">Deal Items</h3>
              <p className="text-gray-700 whitespace-pre-line leading-snug">
                {Array.isArray(item.name) 
                  ? item.name.join("\n") 
                  : item.name.includes(",") 
                    ? item.name.split(",").join("\n")
                    : item.name}
              </p>
            </div>
          )}

          {/* Description */}
          {item.description && item.description.trim() !== "" && (
            <div className="space-y-1">
              <h3 className="text-base font-semibold text-gray-800">Description</h3>
              <p className="text-gray-600 whitespace-pre-line leading-relaxed">
                {item.description}
              </p>
            </div>
          )}

          {/* Price */}
          <div className="text-green-600 font-bold text-xl sm:text-2xl pt-2">
            {isDeal ? (
              <span>{item.dealQuantity} - ${parseFloat(item.dealPrice || item.price || 0).toFixed(2)}</span>
            ) : (
              <span>${typeof item.price === 'number' 
                ? item.price.toFixed(2) 
                : parseFloat(item.price || 0).toFixed(2)}
              </span>
            )}
          </div>

          {/* Bulk Pricing */}
          {!isDeal && item.hasBulkPricing && item.bulkOptions?.length > 0 && (
            <div className="text-green-700 font-medium text-sm mt-2 space-y-1">
              <p className="text-sm text-gray-700 font-semibold">Bulk Pricing:</p>
              {item.bulkOptions.map((option, index) => (
                <div 
                  key={index} 
                  className="flex justify-between text-sm"
                >
                  <span>{option.quantity}x</span>
                  <span>${parseFloat(option.price).toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t flex justify-end bg-gray-50">
          <button 
            onClick={onClose}
            className="px-5 py-2 bg-green-600 text-white hover:bg-green-700 rounded-lg shadow transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
